import {Prescriber} from '_redux/admin/prescribers/admin-prescriber-model.types';
import {Therapist} from '_redux/admin/therapists/admin-therapist-model.types';
import {schema} from 'normalizr';

export const therapistEntity = new schema.Entity<Therapist>(
  'therapists',
  {},
  {
    idAttribute: 'therapistId',
  },
);

export const prescriberEntity = new schema.Entity<Prescriber>(
  'prescribers',
  {},
  {
    idAttribute: 'prescriberId',
  },
);
